// Components
import { MainDiv, Title, GrayText, GrayBoldText, SuccessAlignerDiv, SuccessDiv, SuccessRateValue, SuccessRateText } from "./styles";

const RecentDiagnosticAssessment = ({ qualityControlSessions, constellationsSessions }) => {
  const getSuccessValue = (sessions) => {
    if (!sessions.length) return "-";
    const session = sessions.sort((a, b) => (new Date(a.STARTING_DATE) > new Date(b.STARTING_DATE) ? -1 : 1))[0];
    if (!session?.totalErrors || !session?.totalSuccess) return "-";
    const success = session.totalSuccess;
    const errors = session.totalErrors;
    return parseInt((success / (success + errors)) * 100);
  };

  const renderSuccessRate = (sessions, label) => {
    const successValue = getSuccessValue(sessions);
    const successRate = successValue === "-" ? "-" : `${successValue}%`;
    const isLessThan50 = successValue === "-" ? false : successValue < 50 ? true : false;
    const color = isLessThan50 ? "#F15A24" : "#000";
    return (
      <SuccessDiv border={isLessThan50 ? "1px solid #F15A24" : "none"} background={isLessThan50 ? "#efe3de" : "rgba(242, 242, 242, 0.95)"}>
        <SuccessRateValue color={color}>{successRate}</SuccessRateValue>
        <SuccessRateText color={color}>{label}</SuccessRateText>
      </SuccessDiv>
    );
  };

  return (
    <MainDiv>
      <Title>Recent Diagnostics Assessment</Title>
      <GrayText>
        The Recommender System tracks and optimizes patient recovery using two key activities that assess motor and cognitive functions. The
        image shows the recent success rates for each:
      </GrayText>
      <div>
        <GrayText>
          <GrayBoldText>- CQ (Control Quality) success rate</GrayBoldText> - Assesses motor function with a scale from 0 to 100.
        </GrayText>
        <GrayText>
          <GrayBoldText>- Const. (Constellations) success rate</GrayBoldText> - Assesses cognitive function with a scale from 0 to 100.
        </GrayText>
      </div>
      <SuccessAlignerDiv>
        {renderSuccessRate(qualityControlSessions, "CQ success rate")}
        {renderSuccessRate(constellationsSessions, "Const. success rate")}
      </SuccessAlignerDiv>
    </MainDiv>
  );
};

export default RecentDiagnosticAssessment;
